import React, { useEffect, useState } from "react";

const AdminChat = () => {
  const [chats, setChats] = useState([]);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [keywords, setKeywords] = useState("");
  const [editingId, setEditingId] = useState(null);

  const fetchChats = async () => {
    try {
      const res = await fetch("http://localhost:5000/api/chat/all");
      const data = await res.json();
      setChats(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchChats();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      question,
      answer,
      keywords: keywords.split(",").map(k => k.trim()).filter(k => k)
    };

    try {
      const url = editingId
        ? `http://localhost:5000/api/chat/${editingId}`
        : "http://localhost:5000/api/chat";
      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        setQuestion("");
        setAnswer("");
        setKeywords("");
        setEditingId(null);
        fetchChats();
      } else {
        alert("Error saving chat");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (chat) => {
    setQuestion(chat.question);
    setAnswer(chat.answer);
    setKeywords(chat.keywords.join(", "));
    setEditingId(chat._id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this entry?")) return;
    try {
      await fetch(`http://localhost:5000/api/chat/${id}`, { method: "DELETE" });
      fetchChats();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Chatbot Q&A Admin Panel</h2>

      <form onSubmit={handleSubmit} className="mb-6">
        <input
          type="text"
          placeholder="Question"
          value={question}
          onChange={e => setQuestion(e.target.value)}
          className="border p-2 w-full mb-2"
        />
        <input
          type="text"
          placeholder="Answer"
          value={answer}
          onChange={e => setAnswer(e.target.value)}
          className="border p-2 w-full mb-2"
        />
        <input
          type="text"
          placeholder="Keywords (comma separated)"
          value={keywords}
          onChange={e => setKeywords(e.target.value)}
          className="border p-2 w-full mb-2"
        />
        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          {editingId ? "Update" : "Add"} Q&A
        </button>
      </form>

      <div>
        <h3 className="text-xl font-semibold mb-2">Existing Q&A</h3>
        <ul>
          {chats.map(chat => (
            <li key={chat._id} className="mb-2 border p-2 rounded flex justify-between items-center">
              <div>
                <p><strong>Q:</strong> {chat.question}</p>
                <p><strong>A:</strong> {chat.answer}</p>
                <p><strong>Keywords:</strong> {chat.keywords.join(", ")}</p>
              </div>
              <div className="space-x-2">
                <button onClick={() => handleEdit(chat)} className="bg-blue-500 text-white px-2 py-1 rounded">Edit</button>
                <button onClick={() => handleDelete(chat._id)} className="bg-red-500 text-white px-2 py-1 rounded">Delete</button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminChat;
